import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './plugins/axios';
import VCalendar from 'v-calendar';
import VueIframe from 'vue-iframes';
import { registerFilters } from "../helpers/filters";
registerFilters();
import '../../olsStateManagement/css/olsOverride.sass';

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App),
}).$mount('.registrationRenew')


Vue.use(VCalendar, { componentPrefix: 'vc' });
Vue.use(VueIframe);
